<account-menu [selectedMenu]="4" [me]="me"></account-menu>

<div class="col-lg-9 col-md-9 col-sm-8 content-panel-wrapper nopadding-mobile">

  <h2 class="page-title">Clients</h2>

  <!-- Add Clients -->
  <div class="col-sm-12 nopadding-mobile" *ngIf="mode == 0">
    <div class="panel">
      <div class="panel-title">Add Clients</div>

      <div class="col-sm-12">
        <div class="panel-sub-title-alt">{{title}}</div>

        <div class="clear"></div>

        <div class="push-down-15">
          <!-- Input -->
          <div class="col-md-7 col-sm-9 col-xs-8 nopadding">
            <div class="custom-form-elem">
              <input type="text" placeholder="Client email address" [formControl]="myForm.controls['username']"
                [(ngModel)]="newClient.username" />
            </div>
            <div class="clear"></div>
          </div>

          <!-- Enable Slider -->
          <div class="col-md-2 col-sm-3 col-xs-4 nopadding">
            <div class="enable-slider-sec">
              <div class="slider-title-small">
                Enable
              </div>
              <label class="switch">
                <input type="checkbox" [(ngModel)]="newClient.enabled">
                <span class="slider round"></span>
              </label>
              <div class="clear"></div>
            </div>
            <div class="clear"></div>
          </div>

          <div class="mobile-clear"></div>

          <!-- Button -->
          <div class="col-md-3 col-sm-12 nopadding">
            <div class="clear"></div>
            <button class="custom-form-elem-btn-alt" type="button" (click)="addClient()">Add</button>
            <div class="clear"></div>
          </div>
        </div>

        <div class="clear"></div>


        <div class="form-elem-item">
          <div class="mb-error-fail-alt"
            *ngIf="!myForm.controls['username'].valid && myForm.controls['username'].touched">
            Please enter an email
            address
          </div>
        </div>
        <div class="clear"></div>
      </div>


      <div class="clear"></div>
    </div>
  </div>

  <!-- Clients Table -->
  <div class="col-sm-12 nopadding-mobile" *ngIf="mode == 0">
    <div class="panel">
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="panel-title-left">Clients</div>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-12">

        <div class="col-md-3 col-sm-3 col-xs-3 nopadding">
          <div class="enable-slider-sec">
            <div class="slider-title-small">
              Enable
            </div>
            <label class="switch">
              <input type="checkbox" [(ngModel)]="filterStatus">
              <span class="slider round"></span>
            </label>
            <div class="clear"></div>
          </div>
          <div class="clear"></div>
        </div>

        <div class="col-md-6 col-sm-6 col-xs-6 nopadding">
          <div class="custom-form-elem">
            <input type="text" placeholder="Filter" [(ngModel)]="filter" />
          </div>
        </div>

        <div class="col-md-3 col-sm-3 col-xs-3 nopadding">
          <button class="custom-form-elem-btn" type="button" (click)="filterClients()">Find</button>
        </div>

        <div class="clear"></div>
      </div>

      <div class="clear"></div>

      <div class="col-sm-12">
        <div class="profile-sec-wrap">
          <div class="">
            <div class="col-md-5 col-sm-5 col-xs-5 mb-table-title text-left">Username</div>
            <div class="col-md-3 col-sm-3 col-xs-3 nopadding-mobile mb-table-title">Registered</div>
            <div class="col-md-2 col-sm-2 col-xs-2 nopadding-mobile mb-table-title">Issued Sessions</div>
            <div class="col-md-2 col-sm-2 col-xs-2 nopadding-mobile mb-table-title">Status</div>
            <div class="clear"></div>

            <!-- Repeat per USER -->
            <div class="col-sm-12 nopadding" *ngFor="let item of clientTable">
              <div class="profile-content-alt">
                <div class="col-md-5 col-sm-5 col-xs-5">
                  <div class="mb-table-lg text-left">
                    <button type="button" class="btn-table-icon" (click)="issueSession(item)" *ngIf="item.enabled">
                      <span class="glyphicon glyphicon-tags" aria-hidden="true"></span>
                    </button> &nbsp; {{item.username}}
                  </div>
                </div>

                <div class="col-md-3 col-sm-3 col-xs-3 nopadding-mobile">
                  <div class="mb-table-lg">{{item.isRegistered}}</div>
                </div>

                <div class="col-md-2 col-sm-2 col-xs-2 nopadding-mobile">
                  <div class="mb-table-lg">999</div>
                </div>

                <div class="col-md-2 col-sm-2 col-xs-2 nopadding-mobile">
                  <div class="mb-table-lg">
                    <!-- Enable switch -->
                    <label class="switch">
                      <input type="checkbox" [(ngModel)]="item.enabled" (change)="toggleClientStatus(item)">
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>

                <div class="clear"></div>
              </div>
            </div>

            <div class="clear"></div>
          </div>

          <div class="clear"></div>
        </div>

        <div class="clear"></div>
      </div>

      <div class="clear"></div>
    </div>
  </div>

  <!-- Issue Credit STEP 1 -->
  <div *ngIf="mode == 1">
    <div class="col-lg-8 col-md-10 col-sm-12 col-lg-offset-2 col-md-offset-1 col-sm-offset-0 no-padding-mobile">
      <div class="panel">
        <div class="push-down-10">
          <div class="panel-legend">
            <div class="col-md-4 col-sm-12">
              <div class="panel-legend-inner"><span>1 credit </span> <strong>25 mins</strong></div>
            </div>
            <div class="col-md-4 col-sm-12">
              <div class="panel-legend-inner"><span>2 credits</span> <strong>50 mins</strong></div>
            </div>
            <div class="col-md-4 col-sm-12">
              <div class="panel-legend-inner"><span>3 credits</span> <strong>80 mins</strong></div>
            </div>
          </div>
        </div>

        <div class="clear"></div>
      </div>
    </div>

    <div class="col-sm-12 nopadding-mobile">
      <div class="panel">
        <div class="panel-title">Issue Session</div>
        <p>
          Select the session duratrion you would like to issue.
        </p>

        <div class="clear"></div>

        <div>
          <div class="col-sm-4">
            <div class="profile-sec-wrap">
              <div class="profile-content-alt">
                25 Minutes
              </div>
              <div class="push-down-15">
                <button class="btn-main-proceed-alt" type="button" (click)="issueSessionSelectDuration(1)">
                  Select
                </button>
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="profile-sec-wrap">
              <div class="profile-content-alt">
                50 Minutes
              </div>
              <div class="push-down-15">
                <button class="btn-main-proceed-alt" type="button" (click)="issueSessionSelectDuration(2)">
                  Select
                </button>
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="profile-sec-wrap">
              <div class="profile-content-alt">
                80 Minutes
              </div>
              <div class="push-down-15">
                <button class="btn-main-proceed-alt" type="button" (click)="issueSessionSelectDuration(4)">
                  Select
                </button>
              </div>
            </div>
          </div>
          <div class="clear"></div>
        </div>

        <div class="clear"></div>

        <div class="push-down-20 push-up-10">
          <div class="col-lg-4 col-md-4 col-sm-6 col-lg-offset-4 col-md-offset-4 col-sm-offset-3">
            <button class="btn-main-caution" type="button" (click)="cancelIssueSession()">Cancel</button>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Issue Credit STEP 2 -->
  <div *ngIf="mode == 2">
    <div class="col-lg-8 col-md-10 col-sm-12 col-lg-offset-2 col-md-offset-1 col-sm-offset-0 no-padding-mobile">
      <div class="panel">
        <div class="push-down-10">
          <div class="panel-legend">
            <div class="col-md-4 col-sm-12">
              <div class="panel-legend-inner"><span>1 credit </span> <strong>25 mins</strong></div>
            </div>
            <div class="col-md-4 col-sm-12">
              <div class="panel-legend-inner"><span>2 credits</span> <strong>50 mins</strong></div>
            </div>
            <div class="col-md-4 col-sm-12">
              <div class="panel-legend-inner"><span>3 credits</span> <strong>80 mins</strong></div>
            </div>
          </div>
        </div>

        <div class="clear"></div>
      </div>
    </div>

    <div class="col-sm-12 nopadding-mobile">
      <div class="panel">
        <div class="panel-title">Confirm Selection</div>
        <p>
          Please confirm the details of your selection.
        </p>

        <div class="clear"></div>

        <div class="col-lg-8 col-md-8 col-sm-10 col-lg-offset-2 col-md-offset-2 col-sm-offset-1">
          <div class="profile-sec-wrap">
            <div class="panel-sub-title push-down-15">Session issued to:</div>
            <div class="profile-content">
              {{issueSessionTo.issuedTo}}
            </div>

            <div class="panel-sub-title push-down-15">Duration issued:</div>
            <div class="profile-content push-up-10">
              {{issueSessionTo.duration | duration}}
            </div>
          </div>
        </div>

        <div class="clear"></div>

        <div class="push-down-15 push-up-10">
          <div class="col-lg-4 col-md-4 col-sm-6 col-lg-offset-2 col-md-offset-2 col-sm-offset-0 push-down-10">
            <button class="btn-main-proceed-alt" type="button" (click)="issueSessionConfirm()">Confirm</button>
          </div>

          <div class="col-lg-4 col-md-4 col-sm-6 push-down-10">
            <button class="btn-main-caution" type="button" (click)="cancelIssueSession()">Cancel</button>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Issue Credit STEP 3 -->
  <div *ngIf="mode == 3">
    <div class="col-lg-8 col-md-10 col-sm-12 col-lg-offset-2 col-md-offset-1 col-sm-offset-0 no-padding-mobile">
      <div class="panel">
        <div class="push-down-10">
          <div class="panel-legend">
            <div class="col-md-4 col-sm-12">
              <div class="panel-legend-inner"><span>1 credit </span> <strong>25 mins</strong></div>
            </div>
            <div class="col-md-4 col-sm-12">
              <div class="panel-legend-inner"><span>2 credits</span> <strong>50 mins</strong></div>
            </div>
            <div class="col-md-4 col-sm-12">
              <div class="panel-legend-inner"><span>3 credits</span> <strong>80 mins</strong></div>
            </div>
          </div>
        </div>

        <div class="clear"></div>
      </div>
    </div>

    <div class="col-sm-12 nopadding-mobile">
      <div class="panel">
        <div class="booking-edit-image">
          <img src="/images/session-card-tick-icon.png" />
        </div>

        <div class="panel-title">Success</div>

        <div class="clear"></div>

        <div>
          <p class="profile-content">
            The session has been issued <br />and an email has been sent to:
          </p>

          <p class="profile-content">
            <strong>{{issueSessionTo.issuedTo}}</strong>
          </p>
        </div>

        <div class="clear"></div>

        <div class="push-down-20 push-up-10">
          <div class="col-lg-4 col-md-4 col-sm-6 col-lg-offset-4 col-md-offset-4 col-sm-offset-3">
            <button class="btn-main-proceed-alt" type="button" (click)="cancelIssueSession()">Continue</button>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </div>

</div>
